/** @internal Exported for unit tests. */
export const INVITE_POST_LOGOUT_RETURN_PATH_KEY = 'invitePostLogoutReturnPath';

export const RESUME_INVITE_PATH = '/resume-invite';

export const INVITE_NULL_PATH = '/invite/null';

function isStoredInvitePath(path: string): boolean {
  return path.startsWith('/invite/') && path.length > '/invite/'.length;
}

export function stashInvitePostLogoutReturnPath(pathname: string): void {
  sessionStorage.setItem(INVITE_POST_LOGOUT_RETURN_PATH_KEY, pathname);
}

export function consumeInvitePostLogoutReturnPath(): string | null {
  const path = sessionStorage.getItem(INVITE_POST_LOGOUT_RETURN_PATH_KEY);
  sessionStorage.removeItem(INVITE_POST_LOGOUT_RETURN_PATH_KEY);
  if (!path || !isStoredInvitePath(path)) {
    return null;
  }
  return path;
}

/** Static Auth0 Allowed Logout URL; the invite token is dynamic so it cannot be registered in Auth0 Dashboard. */
export function getInvitePostLogoutReturnToUrl(): string {
  return `${window.location.origin}${RESUME_INVITE_PATH}`;
}
